import { render, staticRenderFns } from "./DictionariesManage.vue?vue&type=template&id=184e1da8&scoped=true&"
import script from "./DictionariesManage.vue?vue&type=script&lang=js&"
export * from "./DictionariesManage.vue?vue&type=script&lang=js&"
import style0 from "./DictionariesManage.vue?vue&type=style&index=0&id=184e1da8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "184e1da8",
  null
  
)

export default component.exports